import React, { useMemo } from 'react';
import MapView from './MapView';
import { resolveCoordinates } from '../lib/geocode';

// Plots a list of destination records on the shared Leaflet map. Accepts the
// same destination shape used across the app ({ id, name, description, img }).
export default function DestinationsMap({ destinations = [], height = 420, emptyLabel }) {
  const locations = useMemo(() => (
    destinations
      .map((d) => {
        const coords = d.lat && d.lng ? [d.lat, d.lng] : resolveCoordinates(d.name);
        if (!coords) return null;
        return {
          id: d.id,
          lat: coords[0],
          lng: coords[1],
          name: d.name,
          description: d.description,
          photoUrl: d.img || d.photoUrl || '',
        };
      })
      .filter(Boolean)
  ), [destinations]);

  if (locations.length === 0) {
    if (!emptyLabel) return null;
    return (
      <div
        style={{
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f4f6f8',
          borderRadius: 12,
          color: '#7a8894',
          fontSize: 14,
          textAlign: 'center',
          padding: 16,
        }}
      >
        {emptyLabel}
      </div>
    );
  }

  return <MapView locations={locations} height={height} />;
}
